export default "__VITE_ASSET__CAxh3FKo__"